// extracted by mini-css-extract-plugin
export default {"addToWallet":"aLgCha","ticketInfo":"dQJ3mD"};